export default [
    {
        path: "/pages/web/home",
        name: "web-web",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "首页",
        },
        component: () => import("../pages/web/home.vue"),
    },
    {
        path: "/pages/web/course",
        name: "web-course",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "课程",
        },
        component: () => import("../pages/web/course.vue"),
    },
    {
        path: "/pages/web/play",
        name: "web-play",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "播放",
        },
        component: () => import("../pages/web/play.vue"),
    },
    {
        path: "/pages/web/latest",
        name: "web-latest",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "最近",
        },
        component: () => import("../pages/web/latest.vue"),
    },
    {
        path: "/pages/web/logger",
        name: "web-latest",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "更新日志",
        },
        component: () => import("../pages/web/logger.vue"),
    },
    {
        path: "/pages/web/examination",
        name: "web-examination",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "考试",
        },
        component: () => import("../pages/web/examination/index.vue"),
    },
    {
        path: "/pages/web/examination/paper",
        name: "web-examination",
        meta: {
            icon: "el-icon-ali-dingyuehao",
            title: "考试",
        },
        component: () => import("../pages/web/examination/paper.vue"),
    }

]
